// Cookie Banner
(function () {
  'use strict';
  var COOKIE_KEY = 'ws_cookie_ok';

  function getCookie(name) {
    return document.cookie.split('; ').some(function (c) {
      return c.startsWith(name + '=');
    });
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (getCookie(COOKIE_KEY)) return;

    var notice = document.getElementById('cookie-notice');
    if (!notice) return;

    setTimeout(function () {
      notice.classList.add('visible');
    }, 1200);

    var btnAccept = document.getElementById('cookie-accept');
    var btnDecline = document.getElementById('cookie-decline');

    function hide() {
      notice.classList.remove('visible');
      setTimeout(function () { notice.remove(); }, 500);
    }

    if (btnAccept) {
      btnAccept.addEventListener('click', function () {
        setCookie(COOKIE_KEY, '1', 365);
        hide();
      });
    }

    if (btnDecline) {
      btnDecline.addEventListener('click', function () {
        setCookie(COOKIE_KEY, '0', 30);
        hide();
      });
    }
  });
}());
